import { render, staticRenderFns } from "./TodoHeader.vue?vue&type=template&id=cff36b9e&scoped=true&"
import script from "./TodoHeader.vue?vue&type=script&lang=js&"
export * from "./TodoHeader.vue?vue&type=script&lang=js&"
import style0 from "./TodoHeader.vue?vue&type=style&index=0&id=cff36b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff36b9e",
  null
  
)

export default component.exports